import { useRef } from "react";

/** Counts number of component renders. */
export const useRenderCount = (): {
  renderCount: number;
} => {
  const renderCountRef = useRef(0);
  renderCountRef.current += 1;

  return {
    renderCount: renderCountRef.current,
  };
};
